module.exports = __webpack_public_path__ + "img/section2_icon_time.b0e2a7bd.svg";